import { createContext, type RefObject } from 'react';

export const XYChartOverlayRefContext = createContext<
  RefObject<HTMLDivElement | null> | undefined
>(undefined);
